import {ApiService} from './api.service';

export class PossibleDuplicateService extends ApiService {
  constructor(organizationId) {
    super();
    this.organizationId = organizationId;
    this.per = 10;
    this.endpoint = `/organizations/${organizationId}/duplicate_donor_reviews`;
    this.flagsEndpoint = `/organizations/${organizationId}/possible_duplicate_donors`;
  }

  // Paginated grouped list — mirrors DonorService (sends limit=per & page via base paginate()).
  reviews(page = 1, params = null) {
    return this.paginate(page, params);
  }
  review(primaryDonorId) {
    return this.get(`${this.endpoint}/${primaryDonorId}`).then((res) => res.json);  }
  keepSeparate(flagId) {
    return this.patch(`${this.flagsEndpoint}/${flagId}/keep_separate`, {}).then((res) => res.json);
  }

  merge(survivingDonorId, duplicateDonorId) {
    return this.post(`/organizations/${this.organizationId}/donor_merges`, {
      surviving_donor_id: survivingDonorId,
      duplicate_donor_id: duplicateDonorId
    }).then((res) => res.json);  }
}
